/***************************************************************************/
"use client";
/***************************************************************************/

import { X } from "lucide-react";
import * as React from "react";
import { cn } from "../../../utils/css";
import { Button, ButtonIcon, TButtonProps } from "../button";
import { AlertContext } from "./alert";

const AlertCloseButton: React.FC<TButtonProps> = ({
  className,
  size,
  ...props
}) => {
  const contextValue = React.useContext(AlertContext);

  return (
    <Button
      variant="ghost"
      className={cn(
        "absolute top-0 right-0",
        "p-2 text-neutral-500 min-h-min min-w-min h-auto w-auto",
        className,
      )}
      size={size ?? contextValue.size}
      {...props}
    >
      <ButtonIcon>
        <X />
      </ButtonIcon>
    </Button>
  );
};

export { AlertCloseButton };
